import React, { Component } from "react";
import FileUploader from "../../../Utilities/Helpers/FileUploader/FileUploader";
import ComponentTemplate from "../../../Utilities/TemplateWrappers/ComponentTemplate";
import {
    List,
    ListItem,
    ListItemText,
    Button,
    IconButton,
    ListItemSecondaryAction,
} from "@material-ui/core";
import {
    RemoveRedEye as ViewIcon,
    Delete as DeleteIcon,
} from "@material-ui/icons";
// import { goToLink, getAllFiles, uploadFile, setFileType } from "./actions";
import { connect } from "react-redux";

import { bindActionCreators } from "redux";

class JobPackGeneralFiles extends Component {
    constructor(props) {
        super(props);
        props.getAllFiles();
        props.getFolders();

        this.state = {
            ogProfile: props.profile,
            profile: props.profile,
            edit: this.props.edit,
            addFileModal: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }

    render() {
        const { profile, edit } = this.state;

        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={true}
                label={this.props.title}
            >
                <List dense={false} style={{ padding: 12 }}>
                    {profile.attached_files &&
                        profile.attached_files.map((e, i) => {
                            return (
                                <ListItem>
                                    {" "}
                                    <ListItemText primary={e.file} />
                                    <ListItemSecondaryAction>
                                        {!this.state.edit && !this.props.new && (
                                            <IconButton
                                                onClick={() => {
                                                    this.props.goToLink(
                                                        `/pdf-viewer/jobpacks/${profile.status}/${this.props.year}/${this.props.month}/${profile.job_id}/attached-files/${i}`
                                                    );
                                                }}
                                            >
                                                <ViewIcon />
                                            </IconButton>
                                        )}

                                        {this.state.edit && (
                                            <IconButton
                                                aria-label="Delete"
                                                onClick={() => {
                                                    let selFiles = profile.attached_files.filter(
                                                        (f) => f.file !== e.file
                                                    );

                                                    this.props.callback(
                                                        "attached_files",
                                                        selFiles
                                                    );
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        )}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            );
                        })}
                </List>
                {edit && (
                    <Button
                        variant="contained"
                        style={{
                            width: "calc(100% - 48px)",
                            margin: 24,
                            position: "relative",
                            background: "#0188cc",
                            color: "white",
                        }}
                        onClick={() => this.setState({ addFileModal: true })}
                    >
                        Select/Upload Files
                    </Button>
                )}
                {this.state.addFileModal && (
                    <FileUploader
                        multipleUploads={true}
                        isOpen={this.state.addFileModal}
                        closeFileUploader={() =>
                            this.setState({ addFileModal: false })
                        }
                        callback={(files) => {
                            this.props.callback(
                                "attached_files",
                                profile.attached_files
                                    ? [...profile.attached_files, ...files]
                                    : files
                            );
                        }}
                    />
                )}
            </ComponentTemplate>
        );
    }
}
export default connect(
    (store, props) => {
        const { selectors } = props;
        const {
            selectJobPackFiles,
            selectFolders,
            selectFileType,
            selectFiles,
        } = selectors;
        return {
            allFiles: selectFiles(store),
            files: selectJobPackFiles(store),
            folders: selectFolders(store),
            fileType: selectFileType(store),
        };
    },
    (dispatch, ownProps) => {
        const { actions } = ownProps;
        const {
            goToLink,
            getAllFiles,
            uploadFile,
            setFileType,
            getFolders,
        } = actions;
        return {
            ...bindActionCreators(
                { goToLink, getAllFiles, uploadFile, setFileType, getFolders },
                dispatch
            ),
        };
    }
)(JobPackGeneralFiles);
